import React from 'react';

interface BudgetIconTwoProps {
  width?: number;
  height?: number;
  strokeColor?: string;
}

const BudgetIconTwo: React.FC<BudgetIconTwoProps> = ({ width = 50, height = 50, strokeColor = '#495057' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3459_11101)">
        <path
          d="M43.75 26.5625C43.75 21.2019 46.0214 16.0919 50 12.5L43.75 6.24996C41.3827 8.02563 38.2154 8.31123 35.5686 6.98761C32.9219 5.66451 31.25 2.95926 31.25 0H18.75C18.75 2.95938 17.0781 5.66451 14.4314 6.98761C11.7846 8.31116 8.6173 8.02565 6.25 6.24996L0 12.5C3.97857 16.0919 6.25 21.2019 6.25 26.5625C6.25 31.9231 3.97857 37.033 0 40.625L6.25 46.875C8.99743 44.3939 12.7276 43.3026 16.3792 43.9104C20.0314 44.5186 23.2056 46.7621 25 50C26.7944 46.762 29.9688 44.5195 33.6208 43.9104C37.2724 43.3018 41.0026 44.3939 43.75 46.875L50 40.625C46.0214 37.033 43.75 31.9231 43.75 26.5625ZM25 12.5C23.2744 12.5 21.875 11.1005 21.875 9.37496C21.875 7.6494 23.2744 6.24996 25 6.24996C26.7256 6.24996 28.125 7.6494 28.125 9.37496C28.125 11.1005 26.7256 12.5 25 12.5Z"
          fill={strokeColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_3459_11101">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BudgetIconTwo;
